var $cdnjs = {
    "picturefill": "https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.min.js",
    "googlemap": "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHt8YWX5Zzs8InkVLjD9TA8aHLy-P-eaY"
};